import React, { useState } from 'react';
import './contact.css';
import emailjs from 'emailjs-com';

function ContactDE() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm('default_service', 'template_74ienqs', e.target, 'PRb_GDLhvtr54sgUl')
      .then((result) => {
        console.log(result.text);
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setStatus(null), 3000);
      }, (error) => {
        console.log(error.text);
        setStatus('error');
        setTimeout(() => setStatus(null), 3000);
      });
  };

  return (
    <div className="ContactPage">
      <h2>Kontaktaufbau</h2>

      <div className="ContactForm">
        <form onSubmit={handleSubmit} id="form">
          <div className="form-group">
            <label className="field-label" htmlFor="name">Ihr Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Wie darf ich sie nennen?"
              required
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="email">Ihre Email Adresse</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Wo soll ich Ihnen antworten?"
              required
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="phone">Ihre Telefonnummer (Optional)</label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Darf ich sie anrufen?"
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="message">Ihre Persönliche Nachricht</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Was liegt ihnen noch auf dem Herzen?"
              rows="6"
              required
            />
          </div>

          <button 
            type="submit" 
            id="button" 
            className={status ? `status-${status}` : ''}
            disabled={status === 'sending'}
          >
            {status === 'sending' && 'Wird gesendet...'}
            {status === 'success' && 'Erfolgreich gesendet!'}
            {status === 'error' && 'Fehlgeschlagen! Bitte erneut versuchen'}
            {!status && 'Nachricht absenden'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactDE;